import axios from "axios";

export const fetchAllModels = async (cancelToken) => {
    try {
        const { data } = await axios.get(`/api/models`, { cancelToken })
        return data
    } catch (error) {
        throw error
    }
};

export const fetchFileListData = async (cancelToken) => {
    try {
        const { data } = await axios.get(`/api/mp`, { cancelToken })
        return data
    } catch (error) {
        throw error
    }
};

export const uploadModel = modelPayload => {  
    let data = modelPayload
    return axios.post(`/api/mp/upload`, data);
};

export const approveModel = payload => {
    const {model_id, decimationSetting, backgroundColor} = payload
    let data = payload
    return axios.post(`/api/mp/approve/${model_id}/${decimationSetting}/${backgroundColor}`, data)
}

export const removeModel = id => {
    return axios.delete(`/api/mp/cancel/${id}`)
}